// frontend/src/utils/generatePdf.ts
import { saveAs } from 'file-saver';
import type { PublicDosingBatch } from '@/types/publicDosing';
// FIX C1: Import from centralized analytics utility
import { trackEvent } from '@/utils/analytics';

// FIX A3: Custom error class for PDF generation failures
export class PdfGenerationError extends Error {
  constructor(message: string, public readonly cause?: unknown) {
    super(message);
    this.name = 'PdfGenerationError';
  }
}

/**
 * Lazy-loads PDF renderer and generates downloadable PDF
 * FIX A3: Wrapped in try/catch with proper error handling
 */
export async function generateBatchPdf(batch: PublicDosingBatch): Promise<void> {
  // Track PDF generation start
  trackEvent('file_download', {
    file_name: `${batch.name}.pdf`,
    file_extension: 'pdf',
    item_category: 'public_tools',
    content_type: 'dosing_batch',
  });

  try {
    // Lazy load the heavy PDF libraries
    const [{ pdf }, { BatchPDF }] = await Promise.all([
      import('@react-pdf/renderer'),
      import('@/components/public-dosing/BatchPDF'),
    ]);

    // Generate PDF blob
    const blob = await pdf(<BatchPDF batch={batch} />).toBlob();

    // Sanitize filename
    const filename = `${batch.name.replace(/[^a-z0-9]/gi, '_')}_dosing_batch.pdf`;

    // Trigger download
    saveAs(blob, filename);

    // Track success
    trackEvent('pdf_generated', {
      content_type: 'dosing_batch',
      success: true,
    });
  } catch (error) {
    // FIX A3: Track error and re-throw with context
    trackEvent('pdf_error', {
      content_type: 'dosing_batch',
      error_message: error instanceof Error ? error.message : 'Unknown error',
    });
    throw new PdfGenerationError('Failed to generate PDF. Please try again.', error);
  }
}
